export const SCACHE_GROUPS = "wms.ra.session.cache.groups";
export const SCACHE_USER = "wms.ra.session.user.info";
